"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontEndAddExternalUserSchema = exports.frontEndAddUserSchema = exports.userSchema = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
var contact_1 = require("./contact");
var internal_contact_1 = require("./internal-contact");
var status_1 = require("./status");
var user_access_1 = require("./user-access");
exports.userSchema = joi_1.default.object({
    userID: joi_1.default.string().guid({ version: 'uuidv4' }),
    emailID: joi_1.default.string()
        .min(0)
        .max(80)
        .email({ tlds: { allow: false } })
        .required(),
    userTypeCode: joi_1.default.number()
        .integer()
        .valid(constants_1.UserType.Internal, constants_1.UserType.External)
        .required(),
    contact: contact_1.contact.required(),
    internalContact: internal_contact_1.internalContact.when('userTypeCode', {
        is: constants_1.UserType.Internal,
        then: joi_1.default.optional(),
        otherwise: joi_1.default.forbidden(),
    }),
    status: status_1.status,
    userAccesses: joi_1.default.array()
        .items(user_access_1.userAccess)
        .min(1)
        .required(),
});
exports.frontEndAddUserSchema = exports.userSchema.keys({
    userAccesses: joi_1.default.array()
        .items(user_access_1.frontEndAddUserAccess)
        .required(),
});
/**
 * When internal admin user is trying to create an external user
 *
 */
exports.frontEndAddExternalUserSchema = exports.userSchema.keys({
    userAccesses: joi_1.default.array()
        .items(user_access_1.frontEndAddExternalUserAccess)
        .required(),
});
